import { ApolloClient, ObservableQuery } from "@apollo/client"

// Skipped queries are in standby and not part of "active", so this only finds queries that
// something on screen is currently rendering.
export function getActiveQueries(
  client: ApolloClient<object>,
  queryNames: string[],
  variables?: Record<string, unknown>
): ObservableQuery[] {
  return [...client.getObservableQueries("active").values()].filter(
    query =>
      !!query.queryName &&
      queryNames.includes(query.queryName) &&
      Object.entries(variables ?? {}).every(
        ([key, value]) => query.variables?.[key] === value
      )
  )
}
